<div class="page-container">
  <div class="page-head margin-left-20px">
    <div>
      <div class="page-title">
        <p class="headerName">{{ headerData.materialName }}</p>
      </div>
    </div>
  </div>
  <div class="page-content responsive-height">
    <div>
      <div class="row">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <ng-container
            *ngrxLet="projectFacade.getMyAllProjectsScenarioList$ as getMyAllProjectsScenarioList"
          >
            <piqet-angular-portlet
              *ngIf="sharedData.dataLoaded"
              [class]="'fixedHeight'"
              [class]="'detail-cell-renderer'"
              [columnDefs]="columnDefs"
              [headerBtn]="'Edit manufacturing'"
              [gridData]="getMyAllProjectsScenarioList"
              [gridName]="gridName"
              (openBtnModal)="addManufacturingModal()"
              [isClearSearch]="sharedData.isClearSearch"
            ></piqet-angular-portlet>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-start">
    <!-- <button type="button" class="btn save-btn modelBTN">Save</button> -->
    <button type="button" class="btn next-btn modelBTN" (click)="change()">
      Next <i class="bi bi-arrow-right" style="margin-left: 15px"></i>
    </button>
  </div>
</div>
